// Imports
import { useEffect } from 'react';
import { useAppSelector } from '../../../shareables/foundation/front-end/redux/hooks';


// Extend interface
declare global {
	function Upscope(command: 'init', options: Record<string, unknown>): void;
	function Upscope(
		command: 'updateConnection',
		options?: {
			identities: string[];
			uniqueId: number;
		}
	): void;
	interface Window {
		upscopeReady?: boolean;
	}
}


// Function component
const UpscopeLoader = () => {
	// Use Redux functionality
	const user = useAppSelector((state) => state.common.user);
	const member = useAppSelector((state) => state.self.member);
	
	
	// Handle Upscope
	useEffect(() => {
		// Return early
		if (!member?.privileges?.length || member.account.suspended || !user || typeof window.Upscope === 'function') {
			return;
		}
		
		
		// Load the Upscope script
		const i: typeof Upscope & { q?: unknown[][] } = function (...args: unknown[]) {
			i.q?.push(args);
		};
		
		i.q = [];
		
		const loader = () => {
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;
			script.src = 'https://code.upscope.io/bo8WtQh9K1bszUohcvMzMckw.js';
			
			const firstScript = document.getElementsByTagName('script')[0];
			firstScript.parentNode?.insertBefore(script, firstScript);
		};
		
		window.Upscope = i;
		loader();
		
		
		// Initialize Upscope
		window.Upscope('init', {
			requireAuthorizationForSession: true,
			authorizationPromptTitle: 'Screen sharing',
			maskedElements: ['[data-private]'],
		});
		
		window.Upscope('on', 'connection', () => {
			window.upscopeReady = true;
			window.dispatchEvent(new Event('upscope-ready'));
		});
		
		
		// Identify the user
		window.Upscope('updateConnection', {
			identities: [user.name ?? '', user.email ?? ''],
			uniqueId: member.id,
		});
	}, [member?.privileges, member?.account.suspended, member?.id, user]);
	
	
	// Render nothing
	return null;
};

export default UpscopeLoader;
